export function isArrayEmpty(array?: { items?: unknown[] | null } | null | undefined) {
  return !array || !array?.items?.length
}

export function getArrayLength(array?: { items?: unknown[] | null } | null, defValue?: number) {
  if (array?.items?.length) return array.items.length
  else return defValue ?? 1
}

export const emptyList = { items: [] }

export function getLastItem<T extends unknown>(array?: T[] | null) {
  return array?.[array?.length - 1] || null
}
